module.exports = __webpack_public_path__ + "20251203d193705t/img/learning-cuate-icon2.d4c465b4.png";